import React, { useRef, useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Password } from "primereact/password";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import { Toast } from "primereact/toast";
import { setLogin } from "../../state";
import api from "../../api";
import withComponentName from "../../withComponentName";

const Signin = () => {
  const dispatch = useDispatch();
  const toast = useRef(null);
  const [checked, setChecked] = useState(false);
  const [require, setRequire] = useState(false);
  const [loading, setLoading] = useState(false);

  const initialSigInInfo = {
    email: "",
    password: "",
    role: "User",
  };
  const [signInInfo, setSignInInfo] = useState(initialSigInInfo);

  const handleInputChange = async (e) => {
    const { name, value } = e.target;
    setSignInInfo({ ...signInInfo, [name]: value });
  };

  const login = async (loginInfo) => {
    setLoading(true);
    try {
      const response = await api.post("/api/auth/login", loginInfo);
      console.log(response.data);
      toast.current.show({
        severity: "success",
        summary: "Login Successful",
        detail: "You have been logged in successfully",
        life: 3000,
      });
      setTimeout(() => {
        dispatch(
          setLogin({
            user: response.data.user,
            token: response.data.token,
          })
        );
      }, 2000);
    } catch (err) {
      console.log(err);
      toast.current.show({
        severity: "error",
        summary: "Failed to Logged In",
        detail: err.response.data.error,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!signInInfo.email || !signInInfo.password) {
      setRequire(true);
      toast.current.show({
        severity: "error",
        summary: "Error in Submission",
        detail: "Please fill all required fields!",
        life: 3000,
      });
      return;
    }

    await login(signInInfo);
    setSignInInfo(initialSigInInfo);
  };

  return (
    <>
      <Header />
      <Toast ref={toast} />

      {/* Split Screen Signin Section */}
      <section className="split-signin-section">
        <div className="split-container">
          {/* Left Side - Login Form */}
          <div className="signin-left-panel">
            <div className="signin-form-container">
              {/* Logo Section */}
              <div className="signin-brand">
                <img
                  src="assets/images/logo.png"
                  className="brand-logo"
                  alt="Platinum Holiday Service"
                />
                <h1 className="brand-name-j">Platinum Holiday Service</h1>
              </div>

              {/* Welcome Section */}
              <div className="welcome-section">
                <h2 className="welcome-title">Welcome back</h2>
                <p className="welcome-subtitle">
                  Please sign in to your account
                </p>
              </div>

              {/* Form Section */}
              <form className="split-signin-form" onSubmit={handleSubmit}>
                <div className="input-group">
                  <label htmlFor="email" className="input-label">
                    Email
                  </label>
                  <InputText
                    id="email"
                    keyfilter="email"
                    className="split-input"
                    name="email"
                    value={signInInfo.email}
                    onChange={handleInputChange}
                    placeholder="Enter your email address"
                  />
                  {require && !signInInfo.email && (
                    <small className="error-text">This field is required</small>
                  )}
                  {!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(signInInfo.email) &&
                    signInInfo.email && (
                      <small className="error-text">Enter valid email</small>
                    )}
                </div>

                <div className="input-group">
                  <label htmlFor="password" className="input-label">
                    Password
                  </label>
                  <Password
                    id="password"
                    className="split-input"
                    name="password"
                    value={signInInfo.password}
                    onChange={handleInputChange}
                    toggleMask
                    feedback={false}
                    placeholder="Enter your password"
                  />
                  {require && !signInInfo.password && (
                    <small className="error-text">
                      This field is required
                    </small>
                  )}
                </div>

                <div className="form-extras">
                  <div className="remember-section">
                    <Checkbox
                      inputId="rememberMe"
                      onChange={(e) => setChecked(e.checked)}
                      checked={checked}
                      className="split-checkbox"
                    />
                    <label htmlFor="rememberMe" className="remember-label">
                      Remember me
                    </label>
                  </div>
                  <a href="/forgot-password" className="forgot-password">
                    Forgot Password?
                  </a>
                </div>

                <Button
                  label="Sign In"
                  className="split-signin-button"
                  loading={loading}
                  disabled={loading}
                />

                <div className="signup-section">
                  <p className="signup-text">
                    Don't have an account?{" "}
                    <a href="/sign-up" className="signup-link">
                      Sign Up
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>

          {/* Right Side - Background Image */}
          <div className="signin-right-panel">
            <div className="image-overlay">
              <div className="overlay-content">
                <h3 className="overlay-title">Premium Airport Parking Services</h3>
                <p className="overlay-description">
                  Secure, convenient, and affordable parking solutions for your travel needs
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default withComponentName(Signin, "Signin");
